import { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { ORDER_NEWEST } from '@common/constants/filters';

const initialState = {
  selectedOrdering: ORDER_NEWEST,
  selectedSizes: [],
  selectedColors: [],
  availableProductsCount: null,
  isFiltered: false,
  allFiltersCount: 0,
  isFiltersModalOpen: false,
  openFiltersModal: () => {},
  closeFiltersModal: () => {},
  setOrdering: () => {},
  setSizes: () => {},
  setColors: () => {},
  setAvailableProductsCount: () => {},
  setIsFiltered: () => {},
};

export const FiltersContext = createContext(initialState);

export const FiltersProvider = ({ children }) => {
  const [selectedOrdering, setOrdering] = useState(ORDER_NEWEST);
  const [selectedSizes, setSizes] = useState([]);
  const [selectedColors, setColors] = useState([]);
  const [availableProductsCount, setAvailableProductsCount] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);

  const allFiltersCount = selectedColors.length + selectedSizes.length;

  const [isFiltersModalOpen, setFiltersModalOpen] = useState(false);

  const openFiltersModal = () => {
    setFiltersModalOpen(true);
  };

  const closeFiltersModal = () => {
    setFiltersModalOpen(false);
  };

  const contextValue = useMemo(
    () => ({
      selectedOrdering,
      selectedSizes,
      selectedColors,
      availableProductsCount,
      isFiltered,
      allFiltersCount,
      isFiltersModalOpen,
      openFiltersModal,
      closeFiltersModal,
      setOrdering,
      setSizes,
      setColors,
      setAvailableProductsCount,
      setIsFiltered,
    }),
    [
      allFiltersCount,
      availableProductsCount,
      isFiltered,
      isFiltersModalOpen,
      selectedColors,
      selectedOrdering,
      selectedSizes,
    ],
  );

  return (
    <FiltersContext.Provider value={contextValue}>
      {children}
    </FiltersContext.Provider>
  );
};

FiltersProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
